import * as React from "react";
import { Button, MenuItem } from "@blueprintjs/core";
import { MultiSelect } from "@blueprintjs/select";

interface Props {
  value: string[];
  onChange: (selected: string[]) => void;
  disabled?: boolean;
};

export class PagamentosMultiselect extends React.Component<Props> {

  handleItemSelect = (item: string) => {

    const { value, onChange } = this.props;

    if (value.includes(item)) {

      onChange(value.filter(i => i !== item));

    } else {

      onChange([...value, item]);

    }

  };

  handleTagRemove = (_tag: string, index: number) => {

    const newSelection = this.props.value.filter((_, i) => i !== index);

    this.props.onChange(newSelection);

  };

  clearAll = () => {

    this.props.onChange([]);

  };

  renderItem = (item: string, { handleClick, modifiers }: any) => {

    if (!modifiers.matchesPredicate) return null;

    return (
      <MenuItem
        key={item}
        text={item}
        onClick={handleClick}
        active={modifiers.active}
        label={this.props.value.includes(item) ? "✓" : undefined}
        disabled={this.props.disabled}
      />
    );
  };

  filterItem = (query: string, item: string) => {
    return item.toLowerCase().includes(query.toLowerCase());
  };

  render() {
    const { value } = this.props;

    return (
      <div>
        <MultiSelect
          items={[]}
          selectedItems={value}
          itemRenderer={this.renderItem}
          tagRenderer={item => item}
          onItemSelect={this.handleItemSelect}
          itemPredicate={this.filterItem}
          // noResults={<MenuItem disabled={true} text="Sem resultados." />}
          popoverProps={{ minimal: true, fill: true }}
          fill={true}
          className="multiselect-permissao"
          placeholder="Digite os códigos"
          createNewItemFromQuery={this.createIps}
          createNewItemRenderer={this.renderCreateIpMenuItem}
          resetOnSelect={true}
          tagInputProps={{
            onRemove: this.handleTagRemove,
            disabled: this.props.disabled
          }}
        />
      </div>
    );
  }

  private createIps(query: string): string | undefined {

    const valor = query.replace(/[./-]/g, "");

    if (!query) return;
    
    return valor;

  }
  

  private renderCreateIpMenuItem = (query: string, active: boolean, handleClick: React.MouseEventHandler<HTMLElement>) => (
    <MenuItem
        icon="add"
        text={`Add "${query}"`}
        active={active}
        onClick={handleClick}
        shouldDismissPopover={false}
        style={{ fontSize: "11px" }}
        disabled={this.props.disabled}
    />
  );
}
 